import { Children } from "../../lib/typeDeclarations";
import "./inline.css";

export default function Inline({ children, style }: { children: Children; style?: React.CSSProperties }) {
  return (
    <div className="inline" style={style}>
      {children}
    </div>
  );
}
